var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c(
        "p",
        {
          staticStyle: {
            margin: "6pt 0cm 11.25pt",
            "caret-color": "#000000",
            color: "#000000",
            "font-variant-caps": "normal",
            "letter-spacing": "normal",
            orphans: "auto",
            "text-indent": "0px",
            "text-transform": "none",
            "white-space": "normal",
            widows: "auto",
            "word-spacing": "0px",
            "-webkit-text-size-adjust": "auto",
            "-webkit-text-stroke-width": "0px",
            "text-decoration": "none",
            "text-align": "center"
          }
        },
        [
          _c("strong", [
            _c("u", [_c("span", [_vm._v("TÉRMINOS Y CONDICIONES")])])
          ])
        ]
      ),
      _c(
        "p",
        {
          staticStyle: {
            margin: "0cm 0cm 0.0001pt",
            "caret-color": "#000000",
            color: "#000000",
            "font-variant-caps": "normal",
            "letter-spacing": "normal",
            orphans: "auto",
            "text-align": "start",
            "text-indent": "0px",
            "text-transform": "none",
            "white-space": "normal",
            widows: "auto",
            "word-spacing": "0px",
            "-webkit-text-size-adjust": "auto",
            "-webkit-text-stroke-width": "0px",
            "text-decoration": "none"
          }
        },
        [
          _c("span", [
            _vm._v(
              "Mediante este contrato se describen los términos y condiciones generales (los "
            ),
            _c("strong", [
              _vm._v("“"),
              _c("u", [_vm._v("Términos y Condiciones Generales")]),
              _vm._v("”) ")
            ]),
            _vm._v(
              "aplicables al acceso y uso de los servicios ofrecidos por Compañía Peruana de Medios de Pago SAC (Niubiz), así como las contendidas en el Contrato de Afiliación al Sistema Niubiz publicadas en el siguiente link: "
            )
          ]),
          _c(
            "a",
            {
              staticStyle: { color: "#954f72", "text-decoration": "underline" },
              attrs: { href: "https://www.visanet.com.pe/contrato-afiliacion" }
            },
            [_vm._v("https://www.visanet.com.pe/contrato-afiliacion")]
          )
        ]
      ),
      _c(
        "p",
        {
          staticStyle: {
            margin: "6pt 0cm 11.25pt",
            "caret-color": "#000000",
            color: "#000000",
            "font-variant-caps": "normal",
            "letter-spacing": "normal",
            orphans: "auto",
            "text-indent": "0px",
            "text-transform": "none",
            "white-space": "normal",
            widows: "auto",
            "word-spacing": "0px",
            "-webkit-text-size-adjust": "auto",
            "-webkit-text-stroke-width": "0px",
            "text-decoration": "none",
            "text-align": "justify"
          }
        },
        [
          _c("span", [
            _vm._v(
              "Cualquier persona jurídica o persona natural que realice actividades comerciales, que posean RUC y que desee acceder y/o usar el sitio o los servicios, podrá hacerlo sujetándose a los Términos y Condiciones Generales descritos en el presente, así como a la Política de Privacidad. En consecuencia, todas las visitas y cada una de las operaciones y transacciones que se realicen en este sitio, así como sus efectos jurídicos, quedarán regidos por estas reglas y sometidas a la legislación aplicable en la República Peruana. Las personas jurídicas necesariamente tendrán un representante legal con poderes suficientes a fin de que puedan contratar y aceptar los términos del presente contrato. En el caso de ser personas naturales con negocio también deberán contar con la capacidad suficiente para contratar."
            )
          ])
        ]
      ),
      _c(
        "p",
        {
          staticStyle: {
            margin: "6pt 0cm 11.25pt",
            "caret-color": "#000000",
            color: "#000000",
            "font-variant-caps": "normal",
            "letter-spacing": "normal",
            orphans: "auto",
            "text-indent": "0px",
            "text-transform": "none",
            "white-space": "normal",
            widows: "auto",
            "word-spacing": "0px",
            "-webkit-text-size-adjust": "auto",
            "-webkit-text-stroke-width": "0px",
            "text-decoration": "none",
            "text-align": "justify"
          }
        },
        [
          _c("span", [
            _vm._v(
              "En forma previa al uso del sitio y/o de los servicios, deberá leer, entender y aceptar todas las condiciones establecidas en estos Términos y Condiciones Generales. Si utiliza este sitio, significa que ha aceptado plenamente las condiciones establecidas en estos Términos y Condiciones Generales y en las Políticas de Niubiz."
            )
          ])
        ]
      ),
      _c(
        "p",
        {
          staticStyle: {
            margin: "6pt 0cm 11.25pt",
            "caret-color": "#000000",
            color: "#000000",
            "font-variant-caps": "normal",
            "letter-spacing": "normal",
            orphans: "auto",
            "text-indent": "0px",
            "text-transform": "none",
            "white-space": "normal",
            widows: "auto",
            "word-spacing": "0px",
            "-webkit-text-size-adjust": "auto",
            "-webkit-text-stroke-width": "0px",
            "text-decoration": "none",
            "text-align": "justify"
          }
        },
        [
          _c("strong", [
            _c("u", [
              _c("span", [
                _vm._v(
                  "CUALQUIER PERSONA NATURAL O JURÍDICA QUE NO ACEPTE ESTOS TÉRMINOS Y CONDICIONES GENERALES, LOS CUALES TIENEN UN CARÁCTER OBLIGATORIO Y VINCULANTE, DEBERÁ ABSTENERSE DE UTILIZAR EL SITIO Y/O LOS SERVICIOS."
                )
              ])
            ])
          ])
        ]
      ),
      _c(
        "p",
        {
          staticStyle: {
            margin: "6pt 0cm 11.25pt",
            "caret-color": "#000000",
            color: "#000000",
            "font-variant-caps": "normal",
            "letter-spacing": "normal",
            orphans: "auto",
            "text-indent": "0px",
            "text-transform": "none",
            "white-space": "normal",
            widows: "auto",
            "word-spacing": "0px",
            "-webkit-text-size-adjust": "auto",
            "-webkit-text-stroke-width": "0px",
            "text-decoration": "none",
            "text-align": "justify"
          }
        },
        [
          _c("span", [
            _vm._v("De aceptar los Términos y Condiciones, declaro: ")
          ])
        ]
      ),
      _c("ol", [
        _c(
          "li",
          {
            staticStyle: {
              "text-align": "justify",
              "line-height": "normal",
              margin: "6.0pt 0cm 11.25pt 36.0pt"
            }
          },
          [_c("strong", [_c("u", [_c("span", [_vm._v("Capacidad")])])])]
        )
      ]),
      _c(
        "p",
        {
          staticStyle: {
            margin: "6pt 0cm 11.25pt",
            "caret-color": "#000000",
            color: "#000000",
            "font-variant-caps": "normal",
            "letter-spacing": "normal",
            orphans: "auto",
            "text-indent": "0px",
            "text-transform": "none",
            "white-space": "normal",
            widows: "auto",
            "word-spacing": "0px",
            "-webkit-text-size-adjust": "auto",
            "-webkit-text-stroke-width": "0px",
            "text-decoration": "none",
            "text-align": "justify"
          }
        },
        [
          _c("span", [
            _vm._v(
              "El usuario declara contar con capacidad legal para aceptar los Términos y Condiciones escritas en este documento, Contrato de Afiliación al Sistema Niubiz y Adendas correspondientes, por ende, contratar. No podrán utilizar los servicios las personas que no tengan esa capacidad como por ejemplo los menores de edad según lo que se dispone en nuestra Legislación Peruana. "
            )
          ])
        ]
      ),
      _c("ol", { attrs: { start: "2" } }, [
        _c(
          "li",
          {
            staticStyle: {
              "text-align": "justify",
              "line-height": "normal",
              margin: "6.0pt 0cm 11.25pt 36.0pt"
            }
          },
          [_c("strong", [_c("u", [_c("span", [_vm._v("Registro")])])])]
        )
      ]),
      _c(
        "p",
        {
          staticStyle: {
            margin: "6pt 0cm 11.25pt",
            "caret-color": "#000000",
            color: "#000000",
            "font-variant-caps": "normal",
            "letter-spacing": "normal",
            orphans: "auto",
            "text-indent": "0px",
            "text-transform": "none",
            "white-space": "normal",
            widows: "auto",
            "word-spacing": "0px",
            "-webkit-text-size-adjust": "auto",
            "-webkit-text-stroke-width": "0px",
            "text-decoration": "none",
            "text-align": "justify"
          }
        },
        [
          _c("span", [
            _vm._v(
              "Es obligatorio completar el formulario de registro en todos sus campos con datos válidos para la adquisición de productos y/o servicios ofrecidos en este sitio. El futuro Usuario deberá completarlo con su información de manera exacta, precisa y verdadera, asume el compromiso de actualizar dichos datos conforme resulte necesario."
            )
          ])
        ]
      ),
      _c("ol", { attrs: { start: "3" } }, [
        _c(
          "li",
          {
            staticStyle: {
              "text-align": "justify",
              "line-height": "normal",
              margin: "6.0pt 0cm 11.25pt 36.0pt"
            }
          },
          [
            _c("strong", [
              _c("u", [_c("span", [_vm._v("Privacidad de la Información")])])
            ])
          ]
        )
      ]),
      _c(
        "p",
        {
          staticStyle: {
            margin: "6pt 0cm 11.25pt",
            "caret-color": "#000000",
            color: "#000000",
            "font-variant-caps": "normal",
            "letter-spacing": "normal",
            orphans: "auto",
            "text-indent": "0px",
            "text-transform": "none",
            "white-space": "normal",
            widows: "auto",
            "word-spacing": "0px",
            "-webkit-text-size-adjust": "auto",
            "-webkit-text-stroke-width": "0px",
            "text-decoration": "none",
            "text-align": "justify"
          }
        },
        [
          _c("span", [
            _vm._v(
              "Para utilizar los Servicios o Productos ofrecidos por Niubiz, el Usuario deberá facilitar determinados datos de carácter personal (en caso de ser persona natural con negocio y/o Empresa Individual de Responsabilidad Limitada). Su información personal se procesa y almacena en servidores o medios magnéticos que mantienen altos estándares de seguridad y protección tanto física como tecnológica. Para más información sobre la privacidad de los Datos Personales y casos en los que será revelada la información personal, se pueden consultar nuestras Políticas de Privacidad que aparecen líneas abajo."
            )
          ])
        ]
      ),
      _c(
        "p",
        {
          staticStyle: {
            margin: "6pt 0cm 11.25pt",
            "caret-color": "#000000",
            color: "#000000",
            "font-variant-caps": "normal",
            "letter-spacing": "normal",
            orphans: "auto",
            "text-indent": "0px",
            "text-transform": "none",
            "white-space": "normal",
            widows: "auto",
            "word-spacing": "0px",
            "-webkit-text-size-adjust": "auto",
            "-webkit-text-stroke-width": "0px",
            "text-decoration": "none",
            "text-align": "justify"
          }
        },
        [
          _c("span", [
            _vm._v(
              "En caso de tratarse de personas jurídicas también se mantienen estándares de seguridad respecto de su información, no resultando aplicable para estos casos la Ley de Protección de Datos Personales."
            )
          ])
        ]
      ),
      _c("ol", { attrs: { start: "4" } }, [
        _c(
          "li",
          {
            staticStyle: {
              "text-align": "justify",
              "line-height": "normal",
              margin: "6.0pt 0cm 11.25pt 36.0pt"
            }
          },
          [
            _c("strong", [
              _c("u", [
                _c("span", [
                  _vm._v(
                    "Modificaciones de los Términos y Condiciones Generales"
                  )
                ])
              ])
            ])
          ]
        )
      ]),
      _c(
        "p",
        {
          staticStyle: {
            margin: "6pt 0cm 11.25pt",
            "line-height": "normal",
            "font-size": "11pt",
            "font-family": "Calibri, sans-serif",
            "caret-color": "#000000",
            color: "#000000",
            "font-variant-caps": "normal",
            "letter-spacing": "normal",
            orphans: "auto",
            "text-indent": "0px",
            "text-transform": "none",
            "white-space": "normal",
            widows: "auto",
            "word-spacing": "0px",
            "-webkit-text-size-adjust": "auto",
            "-webkit-text-stroke-width": "0px",
            "text-decoration": "none",
            "text-align": "justify"
          }
        },
        [
          _c("span", [_vm._v("Niubiz"), _c("em", [_vm._v(" ")])]),
          _c("span", [
            _vm._v(
              "podrá modificar sin previo aviso o notificación los Términos y Condiciones Generales, además del Contrato de Afiliación al Sistema Niubiz y Adendas correspondientes, en cualquier momento haciendo público en el Sitio Web los términos y/o condiciones modificados. Por esta razón recomendamos revisar los Términos y Condiciones cada vez que utilice la página web."
            )
          ])
        ]
      ),
      _c("ol", { attrs: { start: "5" } }, [
        _c(
          "li",
          {
            staticStyle: {
              "text-align": "justify",
              "line-height": "normal",
              margin: "6.0pt 0cm 11.25pt 36.0pt"
            }
          },
          [
            _c("strong", [
              _c("u", [
                _c("span", [
                  _vm._v(
                    "Perfeccionamiento de las operaciones a través de este sitio"
                  )
                ])
              ])
            ])
          ]
        )
      ]),
      _c(
        "p",
        {
          staticStyle: {
            margin: "6pt 0cm 11.25pt",
            "caret-color": "#000000",
            color: "#000000",
            "font-variant-caps": "normal",
            "letter-spacing": "normal",
            orphans: "auto",
            "text-indent": "0px",
            "text-transform": "none",
            "white-space": "normal",
            widows: "auto",
            "word-spacing": "0px",
            "-webkit-text-size-adjust": "auto",
            "-webkit-text-stroke-width": "0px",
            "text-decoration": "none",
            "text-align": "justify"
          }
        },
        [
          _c("span", [
            _vm._v(
              "A través de este sitio web se aceptará las condiciones del Contrato de Afiliación al Sistema Niubiz y Adendas correspondientes. Toda aceptación de oferta quedará sujeta a la condición suspensiva de que Niubiz "
            ),
            _c("em", [_vm._v("valide")]),
            _vm._v(
              "la transacción y registros necesarios, a fin de que en 24 horas se le envíe un correo al usuario confirmando su registro. En consecuencia, para toda operación que se efectúe en este sitio, la confirmación y/o validación y/o verificación por parte de Niubiz"
            ),
            _c("em", [_vm._v(",")]),
            _vm._v("será requisito para el perfeccionamiento de la operación.")
          ])
        ]
      ),
      _c(
        "p",
        {
          staticStyle: {
            margin: "6pt 0cm 11.25pt",
            "caret-color": "#000000",
            color: "#000000",
            "font-variant-caps": "normal",
            "letter-spacing": "normal",
            orphans: "auto",
            "text-indent": "0px",
            "text-transform": "none",
            "white-space": "normal",
            widows: "auto",
            "word-spacing": "0px",
            "-webkit-text-size-adjust": "auto",
            "-webkit-text-stroke-width": "0px",
            "text-decoration": "none",
            "text-align": "justify"
          }
        },
        [
          _c("span", [
            _vm._v(
              "Para informar al usuario acerca de esta validación, Niubiz deberá enviar una confirmación escrita a la misma dirección electrónica que haya registrado el usuario por cualquier medio de comunicación que garantice el debido y oportuno conocimiento del usuario. La operación se entenderá perfeccionada desde el momento en que se envía esta confirmación escrita al usuario y en el lugar en que fue expedida."
            )
          ])
        ]
      ),
      _c(
        "p",
        {
          staticStyle: {
            margin: "6pt 0cm 11.25pt",
            "caret-color": "#000000",
            color: "#000000",
            "font-variant-caps": "normal",
            "letter-spacing": "normal",
            orphans: "auto",
            "text-indent": "0px",
            "text-transform": "none",
            "white-space": "normal",
            widows: "auto",
            "word-spacing": "0px",
            "-webkit-text-size-adjust": "auto",
            "-webkit-text-stroke-width": "0px",
            "text-decoration": "none",
            "text-align": "justify"
          }
        },
        [
          _c("span", [
            _vm._v(
              "La aceptación efectuada por el usuario es irrevocable salvo en circunstancias excepcionales que quedan a criterio de Niubiz."
            )
          ])
        ]
      ),
      _c("ol", { attrs: { start: "6" } }, [
        _c(
          "li",
          {
            staticStyle: {
              "text-align": "justify",
              "line-height": "normal",
              margin: "6.0pt 0cm 11.25pt 36.0pt"
            }
          },
          [
            _c("strong", [
              _c("u", [
                _c("span", [
                  _vm._v("Suspensión e interrupción de la Página Web")
                ])
              ])
            ])
          ]
        )
      ]),
      _c(
        "p",
        {
          staticStyle: {
            margin: "6pt 0cm 11.25pt",
            "caret-color": "#000000",
            color: "#000000",
            "font-variant-caps": "normal",
            "letter-spacing": "normal",
            orphans: "auto",
            "text-indent": "0px",
            "text-transform": "none",
            "white-space": "normal",
            widows: "auto",
            "word-spacing": "0px",
            "-webkit-text-size-adjust": "auto",
            "-webkit-text-stroke-width": "0px",
            "text-decoration": "none",
            "text-align": "justify"
          }
        },
        [
          _c("span", [
            _vm._v(
              "Niubiz se reserva el derecho a suspender, temporalmente y sin previo aviso, el acceso a la Página Web, por tiempo indefinido, debido a la eventual necesidad de efectuar operaciones de mantenimiento, reparación, actualización o mejora de estas o casusas similares. "
            )
          ])
        ]
      ),
      _c(
        "p",
        {
          staticStyle: {
            margin: "6pt 0cm 11.25pt",
            "caret-color": "#000000",
            color: "#000000",
            "font-variant-caps": "normal",
            "letter-spacing": "normal",
            orphans: "auto",
            "text-indent": "0px",
            "text-transform": "none",
            "white-space": "normal",
            widows: "auto",
            "word-spacing": "0px",
            "-webkit-text-size-adjust": "auto",
            "-webkit-text-stroke-width": "0px",
            "text-decoration": "none",
            "text-align": "justify"
          }
        },
        [
          _c("span", [
            _vm._v(
              "Niubiz no garantiza la inexistencia de interrupciones o errores en el acceso a la Página Web, ni será responsable de los retrasos o fallas que se produjeran en el acceso, funcionamiento y operatividad de la misma. "
            )
          ])
        ]
      ),
      _c(
        "p",
        {
          staticStyle: {
            margin: "6pt 0cm 11.25pt",
            "caret-color": "#000000",
            color: "#000000",
            "font-variant-caps": "normal",
            "letter-spacing": "normal",
            orphans: "auto",
            "text-indent": "0px",
            "text-transform": "none",
            "white-space": "normal",
            widows: "auto",
            "word-spacing": "0px",
            "-webkit-text-size-adjust": "auto",
            "-webkit-text-stroke-width": "0px",
            "text-decoration": "none",
            "text-align": "justify"
          }
        },
        [
          _c("span", [
            _vm._v(
              "Niubiz, podrá interrumpir, denegar, bloquear o dar por terminado el acceso a la Página Web o a cualquier funcionalidad de la misma, en cualquier momento y sin previo aviso o ante la detección de cualquier tipo de acto u omisión que, a juicio y a sola discreción de Niubiz, se considere como una violación al contenido de la Página Web.  "
            )
          ])
        ]
      ),
      _c("ol", { attrs: { start: "7" } }, [
        _c(
          "li",
          {
            staticStyle: {
              "text-align": "justify",
              "line-height": "normal",
              margin: "6.0pt 0cm 11.25pt 36.0pt"
            }
          },
          [
            _c("strong", [
              _c("u", [_c("span", [_vm._v("Actualización de la Página Web")])])
            ])
          ]
        )
      ]),
      _c(
        "p",
        {
          staticStyle: {
            margin: "6pt 0cm 11.25pt",
            "caret-color": "#000000",
            color: "#000000",
            "font-variant-caps": "normal",
            "letter-spacing": "normal",
            orphans: "auto",
            "text-indent": "0px",
            "text-transform": "none",
            "white-space": "normal",
            widows: "auto",
            "word-spacing": "0px",
            "-webkit-text-size-adjust": "auto",
            "-webkit-text-stroke-width": "0px",
            "text-decoration": "none",
            "text-align": "justify"
          }
        },
        [
          _c("span", [
            _vm._v(
              "Niubiz se reserva la facultad para modificar la información contenida en la Página Web en cualquier momento y sin previo aviso, así como el derecho de modificar las condiciones de acceso a esta u otros. Las modificaciones entrarán en vigor inmediatamente después de que aparezcan en la Página Web, si necesidad de notificación al Usuario."
            )
          ])
        ]
      ),
      _c("ol", { attrs: { start: "8" } }, [
        _c(
          "li",
          {
            staticStyle: {
              "text-align": "justify",
              "line-height": "normal",
              margin: "6.0pt 0cm 11.25pt 36.0pt"
            }
          },
          [_c("strong", [_c("u", [_c("span", [_vm._v("Promociones")])])])]
        )
      ]),
      _c(
        "p",
        {
          staticStyle: {
            margin: "6pt 0cm 11.25pt",
            "caret-color": "#000000",
            color: "#000000",
            "font-variant-caps": "normal",
            "letter-spacing": "normal",
            orphans: "auto",
            "text-indent": "0px",
            "text-transform": "none",
            "white-space": "normal",
            widows: "auto",
            "word-spacing": "0px",
            "-webkit-text-size-adjust": "auto",
            "-webkit-text-stroke-width": "0px",
            "text-decoration": "none",
            "text-align": "justify"
          }
        },
        [
          _c("span", [
            _vm._v(
              "Las promociones que se ofrezcan en este sitio web no son necesariamente las mismas que ofrezcan otros canales de venta utilizados por Niubiz, por lo que se consideran completamente independientes. "
            )
          ])
        ]
      ),
      _c("ol", { attrs: { start: "9" } }, [
        _c(
          "li",
          {
            staticStyle: {
              "text-align": "justify",
              "line-height": "normal",
              margin: "6.0pt 0cm 11.25pt 36.0pt"
            }
          },
          [
            _c("strong", [
              _c("u", [_c("span", [_vm._v("Despacho de los Productos")])])
            ])
          ]
        )
      ]),
      _c(
        "p",
        {
          staticStyle: {
            margin: "6pt 0cm 11.25pt",
            "caret-color": "#000000",
            color: "#000000",
            "font-variant-caps": "normal",
            "letter-spacing": "normal",
            orphans: "auto",
            "text-indent": "0px",
            "text-transform": "none",
            "white-space": "normal",
            widows: "auto",
            "word-spacing": "0px",
            "-webkit-text-size-adjust": "auto",
            "-webkit-text-stroke-width": "0px",
            "text-decoration": "none",
            "text-align": "justify"
          }
        },
        [
          _c("span", [
            _vm._v(
              "El producto adquirido a través del sitio se sujetará a las condiciones de despacho y entrega disponibles en el sitio. La información del lugar de envío es de exclusiva responsabilidad del usuario. Los plazos elegidos para el despacho y entrega se cuentan desde que Niubiz"
            ),
            _c("em", [_vm._v(" ")]),
            _vm._v(
              "haya validado la orden de compra y el medio de pago utilizado, y se consideran días hábiles para el cumplimiento de dicho plazo. Posterior a la entrega del producto, Niubiz no se responsabiliza por los daños producidos a los productos que sean imputables al cliente o terceros. "
            )
          ])
        ]
      ),
      _c("ol", { attrs: { start: "10" } }, [
        _c(
          "li",
          {
            staticStyle: {
              "text-align": "justify",
              "line-height": "normal",
              margin: "6.0pt 0cm 11.25pt 36.0pt"
            }
          },
          [
            _c("strong", [
              _c("u", [_c("span", [_vm._v("Derecho de retractación ")])])
            ])
          ]
        )
      ]),
      _c(
        "p",
        {
          staticStyle: {
            margin: "6pt 0cm 11.25pt",
            "line-height": "normal",
            "font-size": "11pt",
            "font-family": "Calibri, sans-serif",
            "caret-color": "#000000",
            color: "#000000",
            "font-variant-caps": "normal",
            "letter-spacing": "normal",
            orphans: "auto",
            "text-indent": "0px",
            "text-transform": "none",
            "white-space": "normal",
            widows: "auto",
            "word-spacing": "0px",
            "-webkit-text-size-adjust": "auto",
            "-webkit-text-stroke-width": "0px",
            "text-decoration": "none",
            "text-align": "justify"
          }
        },
        [
          _c("span", [
            _vm._v(
              "En las operaciones realizadas por medio de este sitio, el usuario podrá retractarse de la compra realizada dentro del plazo establecido en el Código de Consumo Peruano."
            )
          ])
        ]
      ),
      _c("ol", { attrs: { start: "11" } }, [
        _c(
          "li",
          {
            staticStyle: {
              "text-align": "justify",
              "line-height": "normal",
              margin: "6.0pt 0cm 11.25pt 36.0pt"
            }
          },
          [
            _c("strong", [
              _c("u", [
                _c("span", [
                  _vm._v("Uso de los datos personales registrados en el sitio")
                ])
              ])
            ])
          ]
        )
      ]),
      _c(
        "p",
        {
          staticStyle: {
            margin: "6pt 0cm 11.25pt",
            "caret-color": "#000000",
            color: "#000000",
            "font-variant-caps": "normal",
            "letter-spacing": "normal",
            orphans: "auto",
            "text-indent": "0px",
            "text-transform": "none",
            "white-space": "normal",
            widows: "auto",
            "word-spacing": "0px",
            "-webkit-text-size-adjust": "auto",
            "-webkit-text-stroke-width": "0px",
            "text-decoration": "none",
            "text-align": "justify"
          }
        },
        [
          _c("span", [
            _vm._v(
              "En el caso de personales naturales con negocio y/o Empresas individuales de Responsabilidad Limitada, los datos referidos en estos términos y condiciones tendrán como finalidad validar las operaciones con el usuario y mejorar la labor de información y comercialización de los productos provistos por Niubiz. Sólo podrán ser entregados a las empresas filiales o relacionadas con el comercio, en ningún caso serán traspasados a terceros. El Usuario acepta la remisión por parte de Niubiz de las promociones y /o campañas necesarias. "
            )
          ])
        ]
      ),
      _c(
        "p",
        {
          staticStyle: {
            margin: "6pt 0cm 11.25pt",
            "caret-color": "#000000",
            color: "#000000",
            "font-variant-caps": "normal",
            "letter-spacing": "normal",
            orphans: "auto",
            "text-indent": "0px",
            "text-transform": "none",
            "white-space": "normal",
            widows: "auto",
            "word-spacing": "0px",
            "-webkit-text-size-adjust": "auto",
            "-webkit-text-stroke-width": "0px",
            "text-decoration": "none",
            "text-align": "justify"
          }
        },
        [
          _c("span", [
            _vm._v(
              "Niubiz garantiza la confidencialidad en el tratamiento de los datos de carácter personal que se solicitan a través de la Página Web. "
            )
          ])
        ]
      ),
      _c("ol", { attrs: { start: "12" } }, [
        _c(
          "li",
          {
            staticStyle: {
              "text-align": "justify",
              "line-height": "normal",
              margin: "6.0pt 0cm 11.25pt 36.0pt"
            }
          },
          [
            _c("strong", [
              _c("u", [
                _c("span", [_vm._v("Violaciones del Sistema o Bases de Datos")])
              ])
            ])
          ]
        )
      ]),
      _c(
        "p",
        {
          staticStyle: {
            margin: "6pt 0cm 11.25pt",
            "caret-color": "#000000",
            color: "#000000",
            "font-variant-caps": "normal",
            "letter-spacing": "normal",
            orphans: "auto",
            "text-indent": "0px",
            "text-transform": "none",
            "white-space": "normal",
            widows: "auto",
            "word-spacing": "0px",
            "-webkit-text-size-adjust": "auto",
            "-webkit-text-stroke-width": "0px",
            "text-decoration": "none",
            "text-align": "justify"
          }
        },
        [
          _c("span", [
            _vm._v(
              "No está permitida ninguna acción o uso de dispositivo, software, u otro medio tendiente a interferir tanto en las actividades y operatoria del comercio comoen las ofertas, descripciones, cuentas o bases de datos del comercio. Cualquier intromisión, tentativa o actividad violatoria o contraria a las leyes sobre derecho de propiedad intelectual y/o a las prohibiciones estipuladas en este contrato harán pasible a su responsable de las acciones legales pertinentes, y a las sanciones previstas por este acuerdo, así como lo hará responsable de indemnizar los daños ocasionados."
            )
          ])
        ]
      ),
      _c("ol", { attrs: { start: "13" } }, [
        _c(
          "li",
          {
            staticStyle: {
              "text-align": "justify",
              "line-height": "normal",
              margin: "6.0pt 0cm 11.25pt 36.0pt"
            }
          },
          [
            _c("strong", [
              _c("u", [_c("span", [_vm._v("Propiedad Intelectual")])])
            ])
          ]
        )
      ]),
      _c(
        "p",
        {
          staticStyle: {
            margin: "6pt 0cm 11.25pt",
            "caret-color": "#000000",
            color: "#000000",
            "font-variant-caps": "normal",
            "letter-spacing": "normal",
            orphans: "auto",
            "text-indent": "0px",
            "text-transform": "none",
            "white-space": "normal",
            widows: "auto",
            "word-spacing": "0px",
            "-webkit-text-size-adjust": "auto",
            "-webkit-text-stroke-width": "0px",
            "text-decoration": "none",
            "text-align": "justify"
          }
        },
        [
          _c("span", [
            _vm._v(
              "Los contenidos de las pantallas relativas a los bienes y/o servicios de Niubiz"
            ),
            _c("em", [_vm._v(" ")]),
            _vm._v(
              "como así también la información, datos, textos gráficos, imágenes, fotografías, audio y video clips, logotipos, iconos, programas, bases de datos, redes, archivos que permiten al Usuario acceder y usar su Cuenta, son de propiedad de Niubiz"
            ),
            _c("em", [_vm._v(" ")]),
            _vm._v(
              "y están protegidas por las leyes y los tratados internacionales de derecho de autor, marcas, patentes, modelos y diseños industriales. El uso indebido y la reproducción total o parcial de dichos contenidos quedan prohibidos, salvo autorización expresa y por escrito de Niubiz. "
            )
          ])
        ]
      ),
      _c(
        "p",
        {
          staticStyle: {
            margin: "6pt 0cm 11.25pt",
            "caret-color": "#000000",
            color: "#000000",
            "font-variant-caps": "normal",
            "letter-spacing": "normal",
            orphans: "auto",
            "text-indent": "0px",
            "text-transform": "none",
            "white-space": "normal",
            widows: "auto",
            "word-spacing": "0px",
            "-webkit-text-size-adjust": "auto",
            "-webkit-text-stroke-width": "0px",
            "text-decoration": "none",
            "text-align": "justify"
          }
        },
        [
          _c("span", [
            _vm._v(
              "Se autoriza la visualización, impresión y descarga parcial del contenido de la Página Web única y exclusivamente cuando estos actos se realicen con el fin de obtener más información sobre Niubiz y/o sus productos para el uso personal y privado del usuario. "
            )
          ])
        ]
      ),
      _c("ol", { attrs: { start: "14" } }, [
        _c(
          "li",
          {
            staticStyle: {
              "text-align": "justify",
              "line-height": "normal",
              margin: "6.0pt 0cm 11.25pt 36.0pt"
            }
          },
          [
            _c("strong", [
              _c("u", [_c("span", [_vm._v(" Suspensión de operaciones")])])
            ])
          ]
        )
      ]),
      _c(
        "p",
        {
          staticStyle: {
            margin: "6pt 0cm 11.25pt",
            "caret-color": "#000000",
            color: "#000000",
            "font-variant-caps": "normal",
            "letter-spacing": "normal",
            orphans: "auto",
            "text-indent": "0px",
            "text-transform": "none",
            "white-space": "normal",
            widows: "auto",
            "word-spacing": "0px",
            "-webkit-text-size-adjust": "auto",
            "-webkit-text-stroke-width": "0px",
            "text-decoration": "none",
            "text-align": "justify"
          }
        },
        [
          _c("span", [
            _vm._v(
              "Sin perjuicio de otras medidas, Niubiz advertirá, suspenderá temporal o inhabilitará definitivamente al usuario, y no le prestará sus Servicios si:"
            )
          ])
        ]
      ),
      _c("ol", { staticStyle: { "padding-left": "1cm" } }, [
        _c(
          "li",
          {
            staticStyle: {
              margin: "6pt 0cm 0.0001pt",
              "caret-color": "#000000",
              color: "#000000",
              "font-variant-caps": "normal",
              "letter-spacing": "normal",
              orphans: "auto",
              "text-indent": "0px",
              "text-transform": "none",
              "white-space": "normal",
              widows: "auto",
              "word-spacing": "0px",
              "-webkit-text-size-adjust": "auto",
              "-webkit-text-stroke-width": "0px",
              "text-decoration": "none",
              "text-align": "justify"
            }
          },
          [
            _c("span", [
              _vm._v(
                " Se quebrantará alguna ley, o cualquiera de las estipulaciones de los Términos y Condiciones Generales, y demás políticas Niubiz."
              )
            ])
          ]
        ),
        _c(
          "li",
          {
            staticStyle: {
              margin: "6pt 0cm 0.0001pt",
              "caret-color": "#000000",
              color: "#000000",
              "font-variant-caps": "normal",
              "letter-spacing": "normal",
              orphans: "auto",
              "text-indent": "0px",
              "text-transform": "none",
              "white-space": "normal",
              widows: "auto",
              "word-spacing": "0px",
              "-webkit-text-size-adjust": "auto",
              "-webkit-text-stroke-width": "0px",
              "text-decoration": "none",
              "text-align": "justify"
            }
          },
          [
            _c("span", [
              _vm._v(" Si incumpliera sus compromisos como Usuario ")
            ])
          ]
        ),
        _c(
          "li",
          {
            staticStyle: {
              margin: "6pt 0cm 0.0001pt",
              "caret-color": "#000000",
              color: "#000000",
              "font-variant-caps": "normal",
              "letter-spacing": "normal",
              orphans: "auto",
              "text-indent": "0px",
              "text-transform": "none",
              "white-space": "normal",
              widows: "auto",
              "word-spacing": "0px",
              "-webkit-text-size-adjust": "auto",
              "-webkit-text-stroke-width": "0px",
              "text-decoration": "none",
              "text-align": "justify"
            }
          },
          [
            _c("span", [
              _vm._v(
                " Si se incurriera a criterio de Niubizen conductas o actos dolosos o fraudulentos."
              )
            ])
          ]
        ),
        _c(
          "li",
          {
            staticStyle: {
              margin: "6pt 0cm 0.0001pt",
              "caret-color": "#000000",
              color: "#000000",
              "font-variant-caps": "normal",
              "letter-spacing": "normal",
              orphans: "auto",
              "text-indent": "0px",
              "text-transform": "none",
              "white-space": "normal",
              widows: "auto",
              "word-spacing": "0px",
              "-webkit-text-size-adjust": "auto",
              "-webkit-text-stroke-width": "0px",
              "text-decoration": "none",
              "text-align": "justify"
            }
          },
          [
            _c("span", [
              _vm._v(
                " No pudiera verificarse la identidad del Usuario o cualquier información proporcionada por el mismo."
              )
            ])
          ]
        )
      ]),
      _c(
        "p",
        {
          staticStyle: {
            margin: "6pt 0cm 11.25pt",
            "caret-color": "#000000",
            color: "#000000",
            "font-variant-caps": "normal",
            "letter-spacing": "normal",
            orphans: "auto",
            "text-indent": "0px",
            "text-transform": "none",
            "white-space": "normal",
            widows: "auto",
            "word-spacing": "0px",
            "-webkit-text-size-adjust": "auto",
            "-webkit-text-stroke-width": "0px",
            "text-decoration": "none",
            "text-align": "justify"
          }
        },
        [
          _c("span", [
            _vm._v(
              "En el caso de la suspensión o inhabilitación de un Usuario serán removidos del sistema, sin lugar a reclamo alguno."
            )
          ])
        ]
      ),
      _c("ol", { attrs: { start: "15" } }, [
        _c(
          "li",
          {
            staticStyle: {
              "text-align": "justify",
              "line-height": "normal",
              margin: "6.0pt 0cm 11.25pt 36.0pt"
            }
          },
          [
            _c("strong", [
              _c("u", [_c("span", [_vm._v("Fallas en el sistema")])])
            ])
          ]
        )
      ]),
      _c(
        "p",
        {
          staticStyle: {
            margin: "6pt 0cm 11.25pt",
            "caret-color": "#000000",
            color: "#000000",
            "font-variant-caps": "normal",
            "letter-spacing": "normal",
            orphans: "auto",
            "text-indent": "0px",
            "text-transform": "none",
            "white-space": "normal",
            widows: "auto",
            "word-spacing": "0px",
            "-webkit-text-size-adjust": "auto",
            "-webkit-text-stroke-width": "0px",
            "text-decoration": "none",
            "text-align": "justify"
          }
        },
        [
          _c("span", [_vm._v("Niubiz"), _c("em", [_vm._v(" ")])]),
          _c("span", [
            _vm._v(
              "no garantiza la inexistencia de eventuales dificultades técnicas o fallas en los sistemas o en Internet. El sistema puede eventualmente no estar disponible debido a dificultades técnicas o fallas de Internet, o por cualquier otra circunstancia ajena a Niubiz; en tales casos se procurará restablecerlo con la mayor celeridad posible. Niubiz"
            ),
            _c("em", [_vm._v(" ")]),
            _vm._v(
              "no garantiza la inexistencia de errores u omisiones en su sitio web."
            )
          ])
        ]
      ),
      _c("ol", { attrs: { start: "16" } }, [
        _c(
          "li",
          {
            staticStyle: {
              "text-align": "justify",
              "line-height": "normal",
              margin: "6.0pt 0cm 11.25pt 36.0pt"
            }
          },
          [
            _c("strong", [
              _c("u", [_c("span", [_vm._v("Tarifas y facturación")])])
            ])
          ]
        )
      ]),
      _c(
        "p",
        {
          staticStyle: {
            margin: "6pt 0cm 11.25pt",
            "caret-color": "#000000",
            color: "#000000",
            "font-variant-caps": "normal",
            "letter-spacing": "normal",
            orphans: "auto",
            "text-indent": "0px",
            "text-transform": "none",
            "white-space": "normal",
            widows: "auto",
            "word-spacing": "0px",
            "-webkit-text-size-adjust": "auto",
            "-webkit-text-stroke-width": "0px",
            "text-decoration": "none",
            "text-align": "justify"
          }
        },
        [
          _c("span", [
            _vm._v(
              "Al adquirir un producto y/o servicio el Usuario deberá pagar el precio publicado y/o tarifas. Niubiz se reserva el derecho de modificar, cambiar, agregar, o eliminar las tarifas vigentes, en cualquier momento, lo cual será publicado en el sitio. Sin embargo, Niubiz"
            ),
            _c("em", [_vm._v(" ")]),
            _vm._v(
              "podrá modificar temporalmente la Política de Tarifas y las tarifas por sus servicios por razón de promociones, siendo efectivas estas modificaciones cuando se haga pública la promoción o se realice el anuncio y hasta la fecha de su finalización. "
            )
          ])
        ]
      ),
      _c(
        "p",
        {
          staticStyle: {
            margin: "6pt 0cm 11.25pt",
            "caret-color": "#000000",
            color: "#000000",
            "font-variant-caps": "normal",
            "letter-spacing": "normal",
            orphans: "auto",
            "text-indent": "0px",
            "text-transform": "none",
            "white-space": "normal",
            widows: "auto",
            "word-spacing": "0px",
            "-webkit-text-size-adjust": "auto",
            "-webkit-text-stroke-width": "0px",
            "text-decoration": "none",
            "text-align": "justify"
          }
        },
        [
          _c("span", [
            _vm._v(
              "En caso de haberse facturado cargos que no hubiesen correspondido, el Usuario deberá comunicarse con nuestro equipo a través de Call Center Niubiz."
            )
          ])
        ]
      ),
      _c(
        "p",
        {
          staticStyle: {
            margin: "6pt 0cm 11.25pt",
            "caret-color": "#000000",
            color: "#000000",
            "font-variant-caps": "normal",
            "letter-spacing": "normal",
            orphans: "auto",
            "text-indent": "0px",
            "text-transform": "none",
            "white-space": "normal",
            widows: "auto",
            "word-spacing": "0px",
            "-webkit-text-size-adjust": "auto",
            "-webkit-text-stroke-width": "0px",
            "text-decoration": "none",
            "text-align": "justify"
          }
        },
        [_c("strong", [_c("u", [_c("span", [_vm._v(" Ley Aplicable")])])])]
      ),
      _c(
        "p",
        {
          staticStyle: {
            margin: "6pt 0cm 11.25pt",
            "caret-color": "#000000",
            color: "#000000",
            "font-variant-caps": "normal",
            "letter-spacing": "normal",
            orphans: "auto",
            "text-indent": "0px",
            "text-transform": "none",
            "white-space": "normal",
            widows: "auto",
            "word-spacing": "0px",
            "-webkit-text-size-adjust": "auto",
            "-webkit-text-stroke-width": "0px",
            "text-decoration": "none",
            "text-align": "justify"
          }
        },
        [
          _c("span", [
            _vm._v(
              "Las condiciones establecidas en este documento se rigen por las leyes vigente en la República Peruana. El usuario renuncia expresamente a cualquier otro fuero, resolviendo cualquier controversia y/o duda mediante trato directo y dentro de los términos de la buena fe. En caso de no llegar a un acuerdo Las Partes, cualquiera podrá someterse para los fines de interpretación, ejecución y alcances del presente documento; al Reglamento de la Cámara de Comercio de Lima, y a la designación de los árbitros por este último."
            )
          ])
        ]
      ),
      _c(
        "p",
        {
          staticStyle: {
            margin: "0cm 0cm 0.0001pt",
            "caret-color": "#000000",
            color: "#000000",
            "font-variant-caps": "normal",
            "letter-spacing": "normal",
            orphans: "auto",
            "text-indent": "0px",
            "text-transform": "none",
            "white-space": "normal",
            widows: "auto",
            "word-spacing": "0px",
            "-webkit-text-size-adjust": "auto",
            "-webkit-text-stroke-width": "0px",
            "text-decoration": "none",
            "text-align": "justify"
          }
        },
        [_c("span", [_vm._v(" ")])]
      ),
      _c(
        "p",
        {
          staticStyle: {
            margin: "0cm 0cm 0.0001pt",
            "caret-color": "#000000",
            color: "#000000",
            "font-variant-caps": "normal",
            "letter-spacing": "normal",
            orphans: "auto",
            "text-align": "start",
            "text-indent": "0px",
            "text-transform": "none",
            "white-space": "normal",
            widows: "auto",
            "word-spacing": "0px",
            "-webkit-text-size-adjust": "auto",
            "-webkit-text-stroke-width": "0px",
            "text-decoration": "none"
          }
        },
        [_vm._v(" ")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35bf6796", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35bf6796","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/affiliation-terms-and-conditions.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-35bf6796","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/affiliation-terms-and-conditions.vue
// module chunks = 32